import { render, staticRenderFns } from "./mainPages.vue?vue&type=template&id=f4697120&scoped=true"
import script from "./mainPages.vue?vue&type=script&lang=js"
export * from "./mainPages.vue?vue&type=script&lang=js"
import style0 from "./mainPages.vue?vue&type=style&index=0&id=f4697120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4697120",
  null
  
)

export default component.exports